/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_FieldsInputs */

const cs_templates_branding_fields = /** @type {(inputs: Templates_Branding_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povinná pole šablony`)
};

const en_templates_branding_fields = /** @type {(inputs: Templates_Branding_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required template fields`)
};

/**
* | output |
* | --- |
* | "Required template fields" |
*
* @param {Templates_Branding_FieldsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_fields = /** @type {((inputs?: Templates_Branding_FieldsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_FieldsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_fields(inputs)
	return cs_templates_branding_fields(inputs)
});